module.exports = __webpack_public_path__ + "static/media/pending_approvals.d7786fdc.svg";